import Vue from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

Vue.component('mic-analyzer-dsgn', {
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root._self;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render(h) {
        const style = {
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            backgroundColor: "silver",
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "inline-block"
        };

        return (
            <div
                style={style}
                class={{ 'designer-container': true, selected: this.selected$ }}
                on-click={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {'|'}
            </div>
        );
    }
});